// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3ZnKm","consentsList":"PatientConsents_consentsList__2Hd6w","consentsListEmpty":"PatientConsents_consentsListEmpty__2GEJX"};